import PropTypes from "prop-types";
import React from "react";
import CommonDialog from "@/Components/Common/CommonDialog";

const RefundModal = ({ show, onRefundClick, onCloseClick, onRefundCompleteClick, data }) => {
  const description = data
    ? `해당 항목을 환불처리 하시겠습니까?\n${data.name} 환불금액: ${data.price}원`
    : "해당 항목을 환불처리 하시겠습니까?";

  return (
    <CommonDialog
      isOpen={show}
      onClose={onCloseClick}
      title="항목 환불"
      description={description}
      tone="destructive"
      actions={[
        {
          label: "닫기",
          color: "light",
          closeOnClick: false,
          onClick: onCloseClick,
        },
        {
          label: "환불",
          color: "danger",
          closeOnClick: false,
          onClick: onRefundClick,
        },
        ...(data && data.type === "deposit"
          ? [
              {
                label: "환불 및 체크아웃 완료",
                color: "danger",
                closeOnClick: false,
                onClick: onRefundCompleteClick,
              },
            ]
          : []),
      ]}
    />
  );
};

RefundModal.propTypes = {
  onCloseClick: PropTypes.func,
  onRefundClick: PropTypes.func,
  show: PropTypes.any,
};

export default RefundModal;
